const ENTITIES: Readonly<Record<string, string>> = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' }

/**
 * De tekst van een stukje citeproc-HTML: zonder tags, met de entiteiten die citeproc gebruikt.
 *
 * Ook het label van een bronvermelding in de tekst (`useSectionCitations`): scherm en revisie tonen
 * dan letterlijk dezelfde vermelding.
 */
export function citationPlainText(html: string): string {
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&(#x[0-9a-f]+|#\d+|[a-z0-9#]+);/gi, (whole, name: string) => {
      if (/^#x/i.test(name)) return String.fromCodePoint(parseInt(name.slice(2), 16))
      if (/^#\d+$/.test(name)) return String.fromCodePoint(parseInt(name.slice(1), 10))
      return ENTITIES[name.toLowerCase()] ?? whole
    })
}
